/* @flow */
import React from 'react';
import Spinner from './Spinner';

type SpinnerOverlayProps = {
  children: any,
  loading: boolean;
  style: Object,
}

let SpinnerOverlay = ({
  children, isLoading = false, style,
}: SpinnerOverlayProps): React.Element => (
    isLoading ? (
      <div
        data-testid="loading-spinner-area"
        style={{
          height: `100%`,
          width: `100%`,
          zIndex: 20,
          display: `flex`,
          justifyContent: `center`,
          alignItems: `center`,
          pointerEvents: `none`,
          backgroundColor: `rgba(0, 0, 0, 0.05)`,
          ...style
        }}
      >
       <Spinner />
      </div>
    ) : children
);

export default SpinnerOverlay;
